import React from 'react';


function Loading_Pages() {
    return (

        <div className="dots-container">
            <div className="dots"></div>
            <div className="dots"></div>
            <div className="dots"></div>
            <div className="dots"></div>
            <div className="dots"></div>
        </div>


    )
}
export default Loading_Pages;